<div class="collectors-container">
  <div class="loading-container" *ngIf="loading">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <div class="collectors-toolbar">
    <input
      id="collectors-search-input"
      type="text"
      class="search-input"
      placeholder="Search by name or team... (min 3 characters)"
      [ngModel]="searchInputValue"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onSearchChanged($event)"
    />
  </div>

  <table
    mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="collectors-table mat-elevation-z2"
  >
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef class="expand-column"></th>
      <td mat-cell *matCellDef="let collector" class="expand-column">
        <button
          mat-icon-button
          type="button"
          class="expand-toggle"
          (click)="toggleExpanded(collector)"
          [attr.aria-label]="
            isExpanded(collector)
              ? 'Collapse collector details'
              : 'Expand collector details'
          "
        >
          <mat-icon class="expand-icon">{{
            isExpanded(collector) ? 'keyboard_arrow_down' : 'chevron_right'
          }}</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let collector">{{ collector.name }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let collector">{{ collector.email || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="team">
      <th mat-header-cell *matHeaderCellDef>Team</th>
      <td mat-cell *matCellDef="let collector">{{ collector.team || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let collector">{{ collector.role || '—' }}</td>
    </ng-container>

    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef>Score</th>
      <td mat-cell *matCellDef="let collector">{{ collector.score }}</td>
    </ng-container>

    <ng-container matColumnDef="rejectionRate">
      <th mat-header-cell *matHeaderCellDef>Rej. Rate</th>
      <td mat-cell *matCellDef="let collector"
        >{{ collector.rejectionRate }}%</td
      >
    </ng-container>

    <ng-container matColumnDef="reliability">
      <th mat-header-cell *matHeaderCellDef>Reliability</th>
      <td mat-cell *matCellDef="let collector">
        <span
          class="state-pill"
          [ngClass]="{
            'state-high': collector.reliability === 'HIGH',
            'state-medium': collector.reliability === 'MEDIUM',
            'state-low': collector.reliability === 'LOW',
            'state-expert': collector.reliability === 'EXPERT'
          }"
        >
          {{ collector.reliability }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="engagement">
      <th mat-header-cell *matHeaderCellDef>Engagement</th>
      <td mat-cell *matCellDef="let collector">
        <span
          class="state-pill"
          [ngClass]="{
            'engagement-backup': collector.engagement === 'BACKUP',
            'state-low': collector.engagement === 'LOW',
            'state-medium': collector.engagement === 'MEDIUM',
            'engagement-average': collector.engagement === 'AVERAGE',
            'state-high': collector.engagement === 'HIGH',
            'engagement-max': collector.engagement === 'MAX'
          }"
        >
          {{ collector.engagement }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="skills">
      <th mat-header-cell *matHeaderCellDef>Skills</th>
      <td mat-cell *matCellDef="let collector">
        {{ collector.skillsAssigned }}/{{ collector.skillsTotal }}
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let collector"
        [attr.colspan]="displayedColumns.length"
        class="detail-cell"
      >
        <app-collector-expanded-detail
          *ngIf="isExpanded(collector)"
          [collector]="collector"
          [config]="config"
        ></app-collector-expanded-detail>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="
        let collector;
        let dataIndex = dataIndex;
        columns: displayedColumns
      "
      class="collector-row hoverable-table-row"
      [class.alt-collector-row]="dataIndex % 2 === 1"
    ></tr>
    <tr
      mat-row
      *matRowDef="let collector; columns: detailRowColumns"
      class="detail-row"
      [class.hidden-detail-row]="!isExpanded(collector)"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell empty-row" [attr.colspan]="displayedColumns.length">
        No collectors found.
      </td>
    </tr>
  </table>

  <div class="collectors-footer">
    <mat-paginator
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChanged($event)"
    ></mat-paginator>

    <div class="footer-actions">
      <button
        mat-stroked-button
        type="button"
        (click)="exportCollectorsCsv()"
        [disabled]="exportingCsv"
      >
        <mat-icon>download</mat-icon>
        Export CSV
      </button>
      <button mat-stroked-button type="button" (click)="openBulkImportDialog()">
        <mat-icon>upload</mat-icon>
        Bulk Import
      </button>
      <div class="inline-add-collector">
        <app-collector-input
          [auth0Id]="addCollectorAuth0Id"
          [displayName]="''"
          [searchScope]="'users'"
          (auth0IdChange)="onAddCollectorAuth0IdChanged($event)"
        ></app-collector-input>
      </div>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="addCollector()"
        [disabled]="!addCollectorAuth0Id"
      >
        <mat-icon>person_add</mat-icon>
        Add Collector
      </button>
    </div>
  </div>
</div>
